import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';   

const ProtectedRoute = () => {
  const { user, loading, openLoginModal } = useAuth();
  const location = useLocation();

  // 当用户未登录且加载完成时，打开登录弹框，并记录当前路径
  useEffect(() => {
    if (!loading && !user) {
      // 将当前路径作为登录成功后跳转的目标
      openLoginModal(location.pathname);
    }
  }, [loading, user, location.pathname, openLoginModal]);

  // 如果正在加载，显示占位
  if (loading) {
    return <div>加载中...</div>;
  }

  // 如果已登录，正常渲染子路由
  if (user) {
    return <Outlet />;
  }

  // 未登录：不渲染任何内容（或显示一个提示），弹框会由 useEffect 触发
  // 注意：这里不能直接跳转，否则会闪烁
  return null;
};

export default ProtectedRoute;